import React, {
  useState,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../components/v2/Button';
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup';
import CoachConfig from '../../../../../../Model/CoachConfig';
import useToast from '../../../../../../hooks/useToast';

import { SettingOption } from '../utils';
import {
  SettingContainer as Container,
  HeaderContainer,
  SettingsActionContainer,
  TitleContainer,
  Title,
  SubTitle,
  ActionLabel,
  StyledSaveIcon,
} from '../styles';

import texts from './texts.json';

const TrackAssignmentSettings = ({ coachConfig }) => {
  const { showToast } = useToast();

  const [shouldEnableTrackAutoAssignment, setShouldEnableTrackAutoAssignment] = useState(
    coachConfig.shouldEnableTrackAutoAssignment,
  );
  const [shouldDisablePublicTrackAssignment, setShouldDisablePublicTrackAssignment] = useState(
    coachConfig.shouldDisablePublicTrackAssignment,
  );

  const handleSave = useCallback(async () => {
    try {
      await coachConfig.set({
        shouldEnableTrackAutoAssignment,
        shouldDisablePublicTrackAssignment,
      }, { merge: true });
      showToast(texts.messageSettingSaveSuccessful);
    } catch (error) {
      showToast(texts.messageSettingSaveFailed, { error: true });
    }
  }, [
    shouldEnableTrackAutoAssignment,
    shouldDisablePublicTrackAssignment,
    coachConfig,
    showToast,
  ]);

  return (
    <Container>
      <HeaderContainer>
        <TitleContainer>
          <Title>{texts.title}</Title>
          <SubTitle>{texts.description}</SubTitle>
        </TitleContainer>
      </HeaderContainer>
      <SettingsActionContainer>
        <ActionLabel>{texts.autoAssignment}</ActionLabel>
        <RadioButtonGroup
          options={[
            {
              label: texts.enabled,
              value: SettingOption.ENABLED,
            },
            {
              label: texts.disabled,
              value: SettingOption.DISABLED,
            },
          ]}
          selectedOption={shouldEnableTrackAutoAssignment ? SettingOption.ENABLED : SettingOption.DISABLED}
          onOptionChange={(value) => setShouldEnableTrackAutoAssignment(value === SettingOption.ENABLED)}
        />
      </SettingsActionContainer>
      <SettingsActionContainer>
        <TitleContainer>
          <ActionLabel>{texts.usePublicTracks}</ActionLabel>
          <SubTitle>{texts.usePublicTracksDescription}</SubTitle>
        </TitleContainer>
        <RadioButtonGroup
          options={[
            {
              label: texts.enabled,
              value: SettingOption.ENABLED,
            },
            {
              label: texts.disabled,
              value: SettingOption.DISABLED,
            },
          ]}
          // The page asks whether to use public tracks; the stored flag is the opposite.
          selectedOption={shouldDisablePublicTrackAssignment ? SettingOption.DISABLED : SettingOption.ENABLED}
          onOptionChange={(value) => setShouldDisablePublicTrackAssignment(value === SettingOption.DISABLED)}
        />
      </SettingsActionContainer>
      <Button onClick={handleSave}>
        <StyledSaveIcon />
        {texts.save}
      </Button>
    </Container>
  );
};

TrackAssignmentSettings.propTypes = {
  coachConfig: PropTypes.instanceOf(CoachConfig).isRequired,
};

export default TrackAssignmentSettings;
